<template>
  <div class="result-container">
    <img class="result-img" :src="resultUrl" alt="" />
    <div class="result-text">{{ resultNull }}</div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'noResultBox',
  props: {
    resultUrl: {
      // 在线缺省Url
      type: String,
      default:
        'https://ump.ems.com.cn/newmail-resources/images/tips/send-box-opened@3x.png'
    },
    resultNull: {
      // 缺省文案
      type: String,
      default: '暂无查询结果'
    }
  }
}
</script>

<style lang="scss" scoped>
.result-container {
  display: flex;
  // height: torem(238px);
  flex-direction: column;
  align-items: center;
  padding: torem(14px);
  margin-bottom: torem(10px);
  background-color: #fff;
  border-radius: torem(8px);

  .result-img {
    width: torem(319px);
    height: torem(180px);
  }

  .result-text {
    margin-top: torem(10px);
    color: #999;
    font-size: torem(14px);
    line-height: torem(20px);
  }
}
</style>
